import { FunctionComponent } from "react";
import { Toast } from "src/context/ToastContext";

interface IToastBoxProps {
    toast: Toast;
}

const ToastBox: FunctionComponent<IToastBoxProps> = ({ toast }) => (
    <div>
        <p>{toast.message}</p>
    </div>
);

export default ToastBox;